import type { FaireProductEntity } from "../../entity_types/product";

export const p_4hhsbdvg8x: FaireProductEntity = {
  token: "p_4hhsbdvg8x",
  type: "product",
  name: "Petale - 8 oz",
  brandToken: "b_64vt8d44",
  brandName: "Le Feu De L'eau",
  imageUrl:
    "https://cdn.faire.com/fastly/9cc0c0a48f28b158862fd19ade36df84e83f766a5dd5d3a772552fa85647afc2.png",
  galleryImageUrls: [],
  priceDollars: 16,
  description:
    "Our 8 oz candles offer the same high-quality scents you love in a minimalist design, reducing waste and keeping costs down. Each candle is wrapped in paper for a simple, sustainable, and affordable presentation.\n\nProduct Notes:\n• Cruelty-free\n• Coconut apricot wax\n• Natural fragrance / Lead-free cotton wicks\n• No phthalates, parabens, sulfates, ethanol, mineral oils, petroleum distillates, or preservatives\n• Poured in small batches in Los Angeles\n• Our most minimal candle with reduced packaging, wrapped in paper.\n\nBurn Time: 40+ hrs",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:46.586Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
